// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3Ycjw","track":"styles__track___1btP_","dot":"styles__dot___1MZhJ","selected":"styles__selected___24N3H"};